import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { StatusGlyph } from '../ui/StatusGlyph';

const STATUS_KEYS = {
  approved: 'status.approved',
  rejected: 'status.rejected',
  manual_review: 'status.manualReview',
} as const;

type TerminalStatus = keyof typeof STATUS_KEYS;

const isTerminalStatus = (value: string | undefined): value is TerminalStatus =>
  value === 'approved' || value === 'rejected' || value === 'manual_review';

/**
 * Terminal status screen. Reached at the end of a flow (/status/:status) or as
 * the catch-all for unknown routes, in which case it renders "unknown status".
 */
export function StatusScreen() {
  const { t } = useTranslation();
  const { status } = useParams<{ status: string }>();

  const messageKey = isTerminalStatus(status)
    ? STATUS_KEYS[status]
    : 'status.unknown';
  const glyph =
    status === 'approved' ? 'success' : status === 'rejected' ? 'error' : 'wait';

  return (
    <main className="screen">
      <div className="card enter">
        <StatusGlyph kind={glyph} />
        <h1 className="step-title">{t(messageKey)}</h1>
      </div>
    </main>
  );
}
